import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SmileMark } from "../brand/Brand";

export default function ImageBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.12, 1.04, 1.12]);

  return (
    <section ref={ref} data-testid="image-band" className="relative bg-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-6 md:py-10">
        <div className="relative smile-holding-shape overflow-hidden bg-diallo-charcoal aspect-[16/10] md:aspect-[21/8]">
          <motion.img
            src="https://images.unsplash.com/photo-1687422808311-a776f467a468?auto=format&fit=crop&w=1920&q=80"
            alt="Une boutique de quartier transformée aux couleurs Diallo, avec un commerçant fier de son commerce"
            style={{ y, scale }}
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
          {/* Spotlight + red wash */}
          <div className="absolute inset-0 bg-gradient-to-t from-diallo-charcoal/85 via-diallo-charcoal/20 to-transparent" />
          <div className="absolute inset-0 mix-blend-multiply bg-diallo-red/10" />

          <div className="absolute inset-0 flex items-end">
            <div className="p-7 md:p-12 max-w-2xl">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              >
                <div className="mb-3 flex items-center gap-2 text-white">
                  <SmileMark color="#FFFFFF" size={30} strokeWidth={7} />
                  <span className="font-display font-semibold tracking-wide uppercase text-sm text-white/80">
                    Le quartier me connaît
                  </span>
                </div>
                <p className="font-display font-extrabold text-2xl md:text-4xl text-white leading-tight">
                  La même boutique, réinventée. Fière, propre, connectée.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
